import { render, staticRenderFns } from "./NewHelpDetailAjax.vue?vue&type=template&id=c98f94d6&"
import script from "./NewHelpDetailAjax.vue?vue&type=script&lang=js&"
export * from "./NewHelpDetailAjax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports